<script>
	import { store } from "../../store.js";
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="30"
	height="30"
	fill="none"
	viewBox="0 0 64 64"
	aria-labelledby={$$props["data-unique_id"] + "_title"}
	aria-describedby={$$props["data-unique_id"] + "_desc"}
>
	<g
		class="mapIcon {$store.options[$$props.id].filtres.mode === 'map'
			? 'active'
			: ''}"
	>
		<path
			d="M32 5a21 21 0 0 0-21 21c0 17 21 33 21 33s21-16 21-33A21 21 0 0 0 32 5zm0 31a10 10 0 1 1 10-10 10 10 0 0 1-10 10z"
		/>
	</g>
</svg>

<style>
	.mapIcon * {
		fill: #888;
		stroke: #888;
		transition: all 0.1s ease-out;
	}
	.mapIcon.active * {
		fill: #3a7c3c;
	}
</style>
